import { ContactFormState } from "../interfaces/contactUs_type";
import { API, APIResponse } from "../components/_Shared/API/API";
import { CREATE_CONTACT_US, GET_CONTACT_US, CONTACT_MARK_AS_SEEN } from "./Endpoints/contact_us";
import AxiosInstance from "@/components/Axios";
import { AxiosResponse } from "axios";

export async function SendContactUsForm(obj: ContactFormState & {recaptcha: string}): Promise<AxiosResponse<ContactFormState>> {
    // Check to see if we're in development mode
    // If we are, then we will set the recaptcha to a mock token
    // TODO: Setup cloudflare recaptcha instead
    // if (process.env.NODE_ENV === "development") {
    obj.recaptcha = "MOCK_TOKEN"
    // }
    const response = await AxiosInstance.post<ContactFormState>(CREATE_CONTACT_US, obj)
    return response
}

export async function GetContactUs(): Promise<APIResponse<ContactFormState[]>> {
    const response = await API.get<ContactFormState[]>(GET_CONTACT_US)
    return response
}

export async function MarkAsSeen(email: string): Promise<APIResponse<ContactFormState>> {
    const response = await API.put<ContactFormState>(CONTACT_MARK_AS_SEEN, {email})
    return response
}
